/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberAssetInputDto { 
    userId: number;
    assetTypeId?: number;
    assetValue?: string | null;
    location?: string | null;
    comments?: string | null;
    documentId?: Array<string> | null;
    id?: number;
}

